"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginLogic = exports.initLaunch = exports.awaitWrap = void 0;
var tslib_1 = require("tslib");
/**
 * 唤起scheme前置工作
 */
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
/**
 *
 * @param {*} promise
 * @returns [data, err]
 */
var awaitWrap = function (promise) { return promise
    .then(function (data) { return [data, null]; })
    .catch(function (err) { return [null, err]; }); };
exports.awaitWrap = awaitWrap;
/**
 * 唤起腾讯会议app初始化入口
 * 1、企业微信且不是私有化微信则进行saas微信初始化
 * @returns wxWorkConfig返回值，wx jsapi success的返回值
 */
var initLaunch = function (initLaunchProps) {
    var 
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _a = initLaunchProps.notCheckLogin, 
    // eslint-disable-next-line @typescript-eslint/naming-convention
    notCheckLogin = _a === void 0 ? false : _a, _b = initLaunchProps.http, http = _b === void 0 ? {
        post: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, void 0];
        }); }); },
        get: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, void 0];
        }); }); },
    } : _b, _c = initLaunchProps.code, code = _c === void 0 ? '' : _c, _d = initLaunchProps.state, state = _d === void 0 ? '' : _d, aegis = initLaunchProps.aegis;
    if ((0, web_base_1.isWxWork)() && !(0, web_base_1.isWxWorkLocal)()) {
        return saasWxInit({ code: code, state: state, notCheckLogin: notCheckLogin, http: http, aegis: aegis });
    }
};
exports.initLaunch = initLaunch;
/**
 * Saas企业微信下初始化
 * @returns wxWorkConfig返回值，wx jsapi success的返回值
 */
var saasWxInit = function (saasWxInitProps) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var code, state, _a, notCheckLogin, http, aegis, notCheckLoginReq, resData, response, newUrl;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                code = saasWxInitProps.code, state = saasWxInitProps.state, _a = saasWxInitProps.notCheckLogin, notCheckLogin = _a === void 0 ? false : _a, http = saasWxInitProps.http, aegis = saasWxInitProps.aegis;
                notCheckLoginReq = (0, web_base_1.getRequest)('not_check_login');
                resData = null;
                if (!notCheckLogin) return [3 /*break*/, 2];
                // 已经消费过oauth
                console.log('>>>>>saasWxInit getSignatureWithLogin');
                return [4 /*yield*/, getSignatureWithLogin(http)];
            case 1:
                resData = _b.sent();
                return [2 /*return*/, wxWorkConfig(resData.data, aegis)];
            case 2:
                if (!code) return [3 /*break*/, 8];
                console.log('>>>>>saasWxInit getSignatureWithCode');
                window.history.replaceState({ url: window.location.href }, document.title, (0, web_base_1.deleteURLSearch)(window.location.href, 'code'));
                if (!(!notCheckLogin && notCheckLoginReq !== 'true')) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, exports.loginLogic)(code, state, http)];
            case 3:
                response = _b.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, getSignatureWithLogin(http)];
            case 4:
                // 已经消费过oauth
                resData = _b.sent();
                return [2 /*return*/, wxWorkConfig(resData.data, aegis)];
            case 5:
                init_aegis_1.default.logAll("[met-component-launchapp]loginLogic-reload, code: ".concat(code));
                newUrl = (0, web_base_1.addURLSearch)(window.location.href, {
                    not_check_login: true,
                });
                window.location.replace(newUrl);
                return [2 /*return*/];
            case 6:
                window.history.replaceState({ url: window.location.href }, document.title, (0, web_base_1.deleteURLSearch)(window.location.href, 'not_check_login'));
                return [4 /*yield*/, getSignatureWithCode(code, http, aegis)];
            case 7:
                resData = _b.sent();
                return [2 /*return*/, wxWorkConfig(resData.data, aegis)];
            case 8: return [2 /*return*/];
        }
    });
}); };
/**
 * oauth登录
 * @param {*} code oauth2 返回的code
 */
var loginLogic = function (code, state, http) {
    if (state === void 0) { state = ''; }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var response, _a, corpId, loginRes;
        var _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    console.log('>>>>>loginLogic');
                    return [4 /*yield*/, login({
                            code: code,
                            state: state,
                        }, http).catch(function (err) {
                            console.log('login error', err);
                            init_aegis_1.default.logAll("[met-component-launchapp]loginLogic-login error, code: ".concat(code, ", catch: "), err);
                            return null;
                        })];
                case 1:
                    response = _c.sent();
                    _a = (((_b = response === null || response === void 0 ? void 0 : response.corp_detail) === null || _b === void 0 ? void 0 : _b[0]) || {}).corp_id, corpId = _a === void 0 ? '' : _a;
                    if (!corpId) return [3 /*break*/, 3];
                    console.log('>>>>>before authLogin corpId', corpId);
                    return [4 /*yield*/, authLogin({
                            auth_code: response.auth_code,
                            identity_type: response.identity_type,
                            corp_id: corpId,
                        }, http)];
                case 2:
                    loginRes = _c.sent();
                    return [2 /*return*/, loginRes];
                case 3:
                    init_aegis_1.default.logAll("[met-component-launchapp]loginLogic-login error, return null, code: ".concat(code, ", response:"), response);
                    return [2 /*return*/, null];
            }
        });
    });
};
exports.loginLogic = loginLogic;
/**
 * web登录（先获取临时授权码，再登录）
 * @param req 登录请求参数
 * @returns
 */
var login = function (req, http) { return new Promise(function (resolve, reject) {
    http.get(enum_1.HttpPrefix.WEMEET_WEB_API, '/v2/account/qy-wechat-auth/login-qr-v2', {
        code: req.code,
        state: req.state,
        error: req.error || '',
    }).then(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.data);
    })
        .catch(function (err) {
        reject(err);
    });
}); };
var authLogin = function (req, http) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var retData, response, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                retData = '';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post(enum_1.HttpPrefix.WEMEET_WEB_API, '/v2/account/login/auth-code', {
                        auth_code: req.auth_code,
                        identity_type: req.identity_type,
                        corp_id: req.corp_id || '',
                        agreement_state: (req === null || req === void 0 ? void 0 : req.agreement_state) || '',
                        country_codes: (req === null || req === void 0 ? void 0 : req.country_codes) || '',
                    })];
            case 2:
                response = _a.sent();
                if (response === null || response === void 0 ? void 0 : response.data) {
                    retData = response === null || response === void 0 ? void 0 : response.data;
                    return [2 /*return*/, retData];
                }
                // eslint-disable-next-line max-len
                init_aegis_1.default.logAll("[met-component-launchapp]loginLogic-authLogin error, return null, req: ".concat(JSON.stringify(req), ", response:"), response);
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                console.error('authLogin request error', e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, retData];
        }
    });
}); };
/**
 * window.wx.ready初始化
 * @param {*} param0
 */
var wxWorkConfig = function (config, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
aegis) {
    if (config === void 0) { config = {}; }
    return new Promise(function (resolve, reject) {
        console.log('>>>>>wxWorkConfig data', config);
        if (config === null || config === void 0 ? void 0 : config.corpId) {
            (0, web_base_1.setCookie)('wework_corp_id', config.corpId, 30);
        }
        else {
            console.log('>>>>>wxWorkConfig failed', config);
            reject();
            return;
        }
        // const configData = {
        //   beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //   appId: config.corpId, // 必填，企业微信的corpID
        //   timestamp: config.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: config.noncestr, // 必填，生成签名的随机串
        //   signature: config.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        //   jsApiList: ['launchApplication', 'getInstallState'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        // };
        // console.log('>>>>>wxWorkConfig configData', configData);
        // (window as any).wx.config(configData);
        // (window as any).wx.ready(() => {
        var agentConfigData = {
            corpid: config.corpId,
            agentid: config.agentId,
            timestamp: config.timestamp,
            nonceStr: config.noncestr,
            signature: config.app_signature,
            jsApiList: ['launchApplication', 'getInstallState'],
            success: function (res) {
                console.log('wx ready success', res);
                init_aegis_1.default.logAll('[met-component-launchapp]wxWorkConfig: window.wx.ready ', res);
                // 成功初始化
                resolve(res);
            },
            fail: function (res) {
                console.log('wx ready fail', res);
                init_aegis_1.default.logAll('[met-component-launchapp]wxWorkConfig: wx ready fail ', res);
                if (res.errMsg.indexOf('function not exist') > -1) {
                    alert('版本过低请升级');
                }
                reject(res);
            },
        };
        console.log('>>>>>wxWorkConfig agentConfigData', agentConfigData);
        if (window.wx.agentConfig) {
            window.wx.agentConfig(agentConfigData);
        }
        else {
            console.log('>>>>>window.wx.agentConfig is undefined!!!!');
            init_aegis_1.default.logAll('[met-component-launchapp]wxWorkConfig: agentConfig is undefined ');
            reject(false);
        }
        // });
        window.wx.error(function (res) {
            console.log('>>>>>wxWorkConfig error', res);
            init_aegis_1.default.logAll('[met-component-launchapp]wxWorkConfig: wx error ', res);
            reject(res);
        });
    });
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getSignatureWithLogin = function (http) { return new Promise(function (resolve, reject) {
    http.get(enum_1.HttpPrefix.WEMEET_WEB_API, '/v2/account/qy-wechat/get-signature-with-login', {
        url: window.location.href,
    }).then(function (res) {
        console.log('>>>>>get-signature-with-login res', res);
        init_aegis_1.default.logAll('[met-component-launchapp]api: v2/account/qy-wechat/get-signature-with-login - then ', res);
        resolve(res);
    })
        .catch(function (err) {
        console.log('>>>>>get-signature-with-login err', err);
        init_aegis_1.default.logAll('[met-component-launchapp]api: v2/account/qy-wechat/get-signature-with-login - catch ', err);
        reject(err);
    });
}); };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getSignatureWithCode = function (code, http, aegis) { return new Promise(function (resolve, reject) {
    http.get(enum_1.HttpPrefix.WEMEET_WEB_API, '/v2/account/qy-wechat/get-signature-with-code', {
        code: code,
        url: window.location.href,
    }).then(function (res) {
        console.log('>>>>>get-signature-with-code res', res);
        init_aegis_1.default.logAll('[met-component-launchapp]api: v2/account/qy-wechat/get-signature-with-code - then ', res);
        resolve(res);
    })
        .catch(function (err) {
        console.log('>>>>>get-signature-with-code err', err);
        init_aegis_1.default.logAll('[met-component-launchapp]api: v2/account/qy-wechat/get-signature-with-code - catch ', err);
        reject(err);
    });
}); };
//# sourceMappingURL=pre-launch.js.map